import { GetSeoDocument, CurrentItemSeoDocument } from '../../graphql/graphql';

export const getSEOData = GetSeoDocument;
export const getItemSEOQuery = CurrentItemSeoDocument;
